import { useState } from "react";
import { updatePrescription } from "../../api/prescriptionService";

export const useUpdatePrescription = (successCallback) => {
  const [updating, setUpdating] = useState(false);
  const update = async (id, data) => {
    setUpdating(true);
    try {
      const updatedRecord = await updatePrescription(id, data);
      setUpdating(false);
      if (successCallback) successCallback(updatedRecord);
      return updatedRecord;
    } catch (error) {
      setUpdating(false);
      console.error("Failed to update prescription:", error);
      throw error;
    }
  };

  return { update, updating };
};